import Select from "common/Select/Select";
import { getOptionText } from "features/configuration/GeneralConfiguration/utils";
import React from "react";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import Link from "common/Typography/Link";
import { typography } from "@shared/common/Themes/typography";
import ModalItem from "features/configuration/GeneralConfiguration/ConfigurationItem/ModalItem";
import useSelectItem from "features/configuration/GeneralConfiguration/FormItem/useSelectItem";
import { FormFieldTitle } from "features/tradingTerminal/common/styles";
import { HelperTooltip } from "common/Tooltips/HelperTooltip";
import { SelectFormItemProps } from "@shared/features/tradingTerminal/common/types";
import { NEW_CUSTOM_STRATEGY_VALUE } from "@shared/features/tradingTerminal/common/constants";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

const SelectFormItem = ({
  item,
  orderType,
  hideBorder,
  hideTitle,
  disabled,
}: SelectFormItemProps) => {
  const {
    itemName,
    options,
    isSelectOpen,
    onSelectClick,
    itemValue,
    handleItemChange,
    prefix,
    suffix,
    isStrategyItem,
    isNewCustomStrategy,
    strategyModalProps,
    itemShouldDisplay,
    tooltipProps,
    onSaveClick,
    onCustomStrategiesClick,
  } = useSelectItem({ item, orderType, disabled });
  const { t } = useTypedTranslation(LanguageNameSpaces.COMMON);

  const getNewOptionText = (option: { name: string; value: string }) => (
    <Flex>
      <Text type="secondary" style={{ fontStyle: "italic" }}>
        {option.name}
      </Text>
      <Link
        $size={typography.fontSizes.S}
        onClick={onSaveClick}
        style={{ padding: "0 8px" }}
      >
        {t("custom_strategy.save")}
      </Link>
    </Flex>
  );

  const strategyExtraButton = (
    <Link $size={typography.fontSizes.S} onClick={onCustomStrategiesClick}>
      {t("custom_strategy.button")}
    </Link>
  );

  return (
    <>
      {!hideTitle && (
        <Flex $alignItems="baseline">
          <Flex $justifyContent="flex-start" $alignItems="flex-start">
            <FormFieldTitle $disabled={!itemShouldDisplay}>
              {itemName}
              {tooltipProps && (
                <HelperTooltip
                  {...tooltipProps}
                  description={t(tooltipProps.description)}
                  title={t(tooltipProps.title)}
                />
              )}
            </FormFieldTitle>
          </Flex>
          {isStrategyItem && strategyExtraButton}
        </Flex>
      )}
      <Select
        value={isNewCustomStrategy ? NEW_CUSTOM_STRATEGY_VALUE : itemValue}
        onChange={(value) => handleItemChange(value, true)}
        open={isStrategyItem ? isSelectOpen : undefined}
        style={{ width: "100%" }}
        showSearch={false}
        bordered={!hideBorder}
        disabled={!itemShouldDisplay || disabled}
        options={(options || []).map((option) => ({
          value: option.value,
          label:
            option.value === NEW_CUSTOM_STRATEGY_VALUE
              ? getNewOptionText(option)
              : getOptionText(option.value, prefix, option, suffix, " "),
        }))}
        onOpenChange={onSelectClick}
        mobileTitle={itemName}
      />
      {isStrategyItem && <ModalItem item={item} {...strategyModalProps} />}
    </>
  );
};

export default SelectFormItem;
